import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Space } from 'antd';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TableColumnInterface } from 'type/tableType';
import * as Component from '../../../../shared/components';
import { CustomButtonComponent } from '../../../../shared/components';
import { playlistApiService } from '../services/playlistApiService';
import { PlaylistInterface } from '../types/playlistType';
import './Playlist.css';

const Playlist: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const columns: TableColumnInterface<PlaylistInterface>[] = [
    {
      title: 'TITLE',
      dataIndex: 'title',
      key: 'title',
      sorter: (a: PlaylistInterface, b: PlaylistInterface) => a.title.localeCompare(b.title),
      render: (text: string, record: PlaylistInterface) => (
        <a
          href="#"
          className="playlist-title"
          onClick={() => navigate(`/playlists/edit/${record.id}`)}
        >
          {text}
        </a>
      ),
    },
    {
      title: 'MRSS URL',
      dataIndex: 'mrss_url',
      key: 'mrss_url',
    },
    {
      title: 'DESCRIPTION',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'TYPE',
      dataIndex: 'type',
      key: 'type',
      sorter: (a: PlaylistInterface, b: PlaylistInterface) => a.type.localeCompare(b.type),
    },
    {
      title: 'CREATED',
      dataIndex: 'created',
      key: 'created',
      sorter: (a: PlaylistInterface, b: PlaylistInterface) => a.created.localeCompare(b.created),
    },
    {
      title: 'ACTIONS',
      key: 'actions',
      dataIndex: 'actions',
      render: (_text: string, record: PlaylistInterface) => (
        <Space>
          <Button
            icon={<SettingOutlined />}
            onClick={() => navigate(`/playlists/edit/${record.id}`)}
            className="action-btn"
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => message.info('You do not have permission')}
            className="action-btn delete-btn"
          />
        </Space>
      ),
    },
  ];

  const AddButton = (): JSX.Element => {
    return (
      <CustomButtonComponent
        text={`+ Add Playlist`}
        onClick={() => navigate('/playlists/add')}
        size={'small'}
      />
    );
  };

  const fetchPlaylist = useCallback(
    async (params: URLSearchParams): Promise<{ data: PlaylistInterface[]; count: number }> => {
      const data = await playlistApiService.fetch(params);
      return { data: data.results, count: data.count };
    },
    []
  );

  return (
    <Component.BasePageComponent>
      <div className="playlist-container">
        <Component.TableComponent<PlaylistInterface>
          name="MRSS Feeds"
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          dataFetch={fetchPlaylist}
          columns={columns}
          additionalButton={[AddButton()]}
        />
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(Playlist);
